import React from 'react';
import { Container } from 'react-bootstrap';
import Border from '../components/Border';

function Terms() {
    const getYear = ()=>{
        return new Date().getFullYear()
    }
  return (
    <Container className='col-lg-10'>
      <Container className="termsHeader" fluid>
          Terms of Use
      </Container>
      <Container className="termsSubheader">
          Effective Date: {(getYear())}
      </Container>
      <Container className="termsText" fluid>
          These Terms of Use ("Terms") govern the use of CranburyCommons.com ("we," "our," "us"), a website offering information and services related to the rental of apartments and shopping plaza building located at 1 Old Trenton Rd, Cranbury, NJ 08512. By accessing or using this website, you ("user," "tenant," "visitor," or "you") agree to abide by and be bound by these Terms. If you do not agree to these Terms, you may not use or access this website.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          1. Use of the Website
      </Container>
      <Container className="termsText" fluid>
          You agree to use the website only for lawful purposes and in accordance with these Terms. You will not engage in any conduct that violates applicable laws or regulations, interferes with the website's operation, or harms other users.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          2. Account Registration
      </Container>
      <Container className="termsText" fluid>
          You may be required to create an account to access certain features of the website. You agree to provide accurate and complete information during registration and maintain the security of your account.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          3. Privacy and Data Collection
      </Container>
      <Container className="termsText" fluid>
          We respect your privacy. Any personal information collected through the website will be handled in accordance with our Privacy Policy. By using the website, you consent to the collection and use of your personal information as described in our Privacy Policy.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          4. Modifications to the Terms
      </Container>
      <Container className="termsText" fluid>
          We reserve the right to modify these Terms at any time. Any changes will be posted on this page with an updated "Effective Date." By continuing to use the website after any changes, you agree to the modified Terms.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          5. Termination
      </Container>
      <Container className="termsText" fluid>
          We may suspend or terminate your access to the website at our discretion if we believe you have violated these Terms.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          6. Privacy and Data Collection
      </Container>
      <Container className="termsText" fluid>
          Your use of the website is subject to our Privacy Policy, which outlines how we collect, use, and protect your personal information. By using this website, you consent to the collection and use of your data in accordance with our Privacy Policy.       
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          7. Disclaimer of Warranties and Limitation of Liability
      </Container>
      <Container className="termsText" fluid>
          The website and all content are provided "as is," without any warranties, express or implied. We do not warrant that the website will be error-free, uninterrupted, or secure. We are not responsible for any damages arising from your use of the website, including loss of data, business interruption, or other indirect, incidental, or consequential damages.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          8. Rental Process and Payments
      </Container>
      <Container className="termsText" fluid>
          By applying for an apartment, you agree to adhere to the rental process, which may include submitting rental applications, providing references, undergoing credit checks, and signing a lease agreement. The terms of the lease will outline your rights and responsibilities as a tenant.<br></br>
          Rental payments are due in accordance with the lease agreement. We may provide payment options via the website, and all payment processing is subject to applicable fees.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          9. Termination of Access
      </Container>
      <Container className="termsText" fluid>
          We reserve the right to terminate or suspend your access to the website if you violate these Terms or engage in any unlawful activities. Upon termination, you must cease using the website and destroy any materials downloaded from it.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          10. Governing Law and Dispute Resolution
      </Container>
      <Container className="termsText" fluid>
          These Terms are governed by the laws of the State of New Jersey. Any disputes arising out of or related to the use of this website or the rental of apartments will be resolved through [mediation/arbitration] in New Jersey. You agree to submit to the exclusive jurisdiction and venue of the courts in New Jersey for any legal proceedings.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          11. Third-Party Links
      </Container>
      <Container className="termsText" fluid>
          The website may contain links to third-party websites for your convenience. We do not endorse or control these external websites and are not responsible for their content or practices. Accessing third-party sites is at your own risk.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          12. User-Generated Content
      </Container>
      <Container className="termsText" fluid>
          If the website allows for the submission of user-generated content (e.g., reviews or feedback), you agree not to post content that:<br></br>
          - Violates the rights of others or is unlawful.<br></br>
          - Contains defamatory, obscene, or offensive material.<br></br>
          - Infringes on any intellectual property rights.<br></br>
          We reserve the right to remove or modify any content that violates these Terms or is deemed inappropriate.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          13. Cookies and Tracking Technologies
      </Container>
      <Container className="termsText" fluid>
          We may use cookies or other tracking technologies to enhance your experience on the website, analyze site usage, and personalize content. By using this website, you consent to the use of cookies in accordance with our Cookie Policy.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
        14. Indemnification
      </Container>
      <Container className="termsText" fluid>
        You agree to indemnify, defend, and hold harmless CranburyCommons.com, its affiliates, employees, and agents from any claims, damages, or liabilities arising from your use of the website or violation of these Terms.        
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          15. Miscellaneous
      </Container>
      <Container className="termsText" fluid>
          - These Terms constitute the entire agreement between you and us regarding the use of the website and supersede any prior agreements or understandings.<br></br>
          - If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions will continue in full force and effect.<br></br>
          - We may assign our rights and obligations under these Terms without notice to you.       
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          16. Copyright Notice
      </Container>
      <Container className="termsText" fluid>
          © {(getYear())} Cranburry Commons LLC. All rights reserved.
      </Container>

      <Border />

      <Container className="termsHeader" fluid>
          Contact Information:
      </Container>

      <Container className="termsText" fluid>
          If you have any questions regarding these Terms, please contact us at:<br></br>
          (732) 937-5080<br></br>
          Keisha@firstpropertyms.com<br></br>
          <a href="https://www.firstpropertyms.net">FirstPropertyms.Net</a><br></br>
      </Container>
    </Container>
  );
}

export default Terms;
